import styled from "styled-components";

export const CardView = styled.div`
    display: none;

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        display: block;
    }
`;

export const Card = styled.div`
    background: white;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const CardField = styled.div`
    margin-bottom: 8px;

    label {
    font-size: 12px;
    color: #999;
    display: block;
    margin-bottom: 4px;
    }

    span {
    color: #333;
    }
`;

export const CardActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eee;
`;

export const ActionButton = styled.button`
background: none;
border: none;
cursor: pointer;
padding: 4px;
color: #666;
transition: color 0.2s;

&:hover {
  color: ${props => props.className?.includes('delete') ? '#DC1E2D' : '#1e88e5'};
}
`;